<div>
    <div class="container width100">
        <app-take-survey-questions [surveyId]="surveyId">
        </app-take-survey-questions>
    </div>
</div>
